/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Raisons de désactivation des actions (clés i18n)
 * @export
 * @interface DisabledReasons
 */
export interface DisabledReasons {
    /**
     * Clé i18n expliquant pourquoi l'envoi est désactivé.
     * Ex: "SEPA_MANDATE_MISSING", "INSURED_INCOMPLETE"
     * 
     * @type {string}
     * @memberof DisabledReasons
     */
    canSendContract?: string;
    /**
     * Clé i18n expliquant pourquoi la signature est désactivée.
     * Ex: "PENDING_VALIDATION", "ALREADY_SIGNED"
     * 
     * @type {string}
     * @memberof DisabledReasons
     */
    canSignContract?: string;
    /**
     * Clé i18n expliquant pourquoi la signature mandat est désactivée.
     * Ex: "SEPA_NOT_ACTIVATED", "MANDATE_ALREADY_SIGNED" ; cabinet payeur :
     * "MANDATE_NO_GERANT" (aucun gérant déclaré), "MANDATE_GERANT_WITHOUT_ACCESS"
     * (le gérant n'a pas de compte), "MANDATE_NOT_GERANT" (le connecté n'est pas gérant).
     * 
     * @type {string}
     * @memberof DisabledReasons
     */
    canSignMandate?: string;
}

/**
 * Check if a given object implements the DisabledReasons interface.
 */
export function instanceOfDisabledReasons(value: object): value is DisabledReasons {
    return true;
}

export function DisabledReasonsFromJSON(json: any): DisabledReasons {
    return DisabledReasonsFromJSONTyped(json, false);
}

export function DisabledReasonsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisabledReasons {
    if (json == null) {
        return json;
    }
    return {
        
        'canSendContract': json['canSendContract'] == null ? undefined : json['canSendContract'],
        'canSignContract': json['canSignContract'] == null ? undefined : json['canSignContract'],
        'canSignMandate': json['canSignMandate'] == null ? undefined : json['canSignMandate'],
    };
}

export function DisabledReasonsToJSON(json: any): DisabledReasons {
    return DisabledReasonsToJSONTyped(json, false);
}

export function DisabledReasonsToJSONTyped(value?: DisabledReasons | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canSendContract': value['canSendContract'],
        'canSignContract': value['canSignContract'],
        'canSignMandate': value['canSignMandate'],
    };
}

